<template>
    <div class="d-flex align-items-center">
        <div>
            На странице:
        </div>
        <div class="pl-2">
            <b-button-group>
                <b-button
                        v-for="(val, i) in getTablePageSizeVariants"
                        size="sm"
                        :variant="getButtonVariant(val)"
                        @click="setPageSize(val)"
                        :key="i">
                    {{ val }}
                </b-button>
            </b-button-group>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import {TableActions} from "../../store/tables/constants";

    export default {
        name: "DataTablePageSizeSelect",
        computed: {
            ...mapGetters(['getTablePageSize', 'getTablePageSizeVariants']),
        },
        props: {
            tableName: { type: String }
        },
        methods: {
            getButtonVariant(val) {
                if (val === this.getTablePageSize(this.tableName)) { return 'primary' }
                return 'secondary';
            },
            setPageSize(size) {
                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_PAGE_SIZE,
                    { name: this.tableName, size: size }
                ).then(() => {
                    this.$emit('page-size-changed', size);
                });
            }
        }
    }
</script>

<style scoped>

</style>